import React from 'react'
import { styled } from '@mui/material/styles'
import { Grid, Box } from '@mui/material'
import { grey, green, yellow, red } from '@mui/material/colors'

const PREFIX = 'CondicionClave'
const classes = {
  estandarClave: `${PREFIX}-estandarClave`,
  noCumple: `${PREFIX}-noCumple`,
  barra: `${PREFIX}-barra`,
}

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.estandarClave}`]: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    width: '444px',
    backgroundColor: grey[100],
    borderRadius: '20px',
  },
  [`& .${classes.noCumple}`]: {
    color: red[500],
    fontWeight: 'bold'
  },
  [`& .${classes.barra}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '20px',
  }
}))

function verificaFortalezaClave(clave) {
  const valores = ({
   minCarac: clave.length >= 10 ? true : false,
   letMay: /[A-Z]/.test(clave) ? true : false,
   letMin: /[a-z]/.test(clave) ? true : false,
   espBlan: /\s/.test(clave) ? false : true,
   num: /[0-9]/.test(clave) ? true : false,
   carEspec: /[$@!%+*?&^|()_.\\\-[\]]/.test(clave) ? true : false,
 })
 return (valores)
}

function CondicionesClave(props) {
  const t = global.t || {} 
  // Se optiene el porcentaje del total completado, como son 6 valores, se multiplica por 16.67
  let progreso = Object.values(props.valores).filter((v) => v).length * 16.67
  let colorBarra = progreso < 50 ? ({height:25, background: red[500], width: progreso+'%'}) : progreso < 100 ? ({height:25, background: yellow[600], width: progreso+'%'}) : ({height:25, background: green[500], width: '100%'})
  let texto = progreso === 0 ? "" : progreso < 50 ? (t.T_DEBIL || 'T_DEBIL') : progreso < 100 ? (t.T_MEDIO || 'T_MEDIO') : (t.T_FUERTE || 'T_FUERTE')
  return (
    <StyledGrid className={(classes.root, classes.estandarClave)} style={Object.values(props.valores).every(Boolean) ? {border: '1px solid rgba(16,112,80,0.50)'} : {border: '1px solid rgba(245,91,79,0.50)'}}>
      <Grid item xs={12}>
        {progreso > 0 &&
          <Box style={colorBarra} className={classes.barra}>{texto}</Box>
        }
        {progreso === 0 &&
          <Box className={classes.barra}>{t.T_CONTRASENIA_NO_VALIDA || 'T_CONTRASENIA_NO_VALIDA'}</Box>
        }
        {t.T_REQUERIMIENTOS_CONTRASENIA || 'T_REQUERIMIENTOS_CONTRASENIA'}<br /><br />
        <Box display='inline-block' className={`${props.valores.minCarac ? '' : classes.noCumple}`}>{`- ${t.T_CARACTERES_MINIMOS || 'T_CARACTERES_MINIMOS'}`}</Box><br />
        <Box display='inline-block' className={`${props.valores.espBlan ? '' : classes.noCumple}`}>{`- ${t.T_SIN_ESPACIOS_BLANCOS || 'T_SIN_ESPACIOS_BLANCOS'}`}</Box><br />
        {t.T_DEBE_CONTENER || 'T_DEBE_CONTENER'} <br />
        <Box display='inline-block' className={`${props.valores.letMay ? '' : classes.noCumple}`}>{`${t.T_UNA_MAYUSCULA || 'T_UNA_MAYUSCULA'},`}</Box>{' '}
        <Box display='inline-block' className={`${props.valores.letMin ? '' : classes.noCumple}`}>{`${t.T_UNA_MINUSCULA || 'T_UNA_MINUSCULA'},`}</Box>{' '}
        <Box display='inline-block' className={`${props.valores.num ? '' : classes.noCumple}`}>{`${t.T_UN_NUMERO || 'T_UN_NUMERO'} y`}</Box>{' '}
        <Box display='inline-block' className={`${props.valores.carEspec ? '' : classes.noCumple}`}>{`${t.T_UN_CARACTER_ESPECIAL || 'T_UN_CARACTER_ESPECIAL'}`}</Box>
      </Grid>
    </StyledGrid>
  )
}

export {
  verificaFortalezaClave,
  CondicionesClave,
}